<template>
    <div>
        <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #F3F3F3; padding: 12px 20px">
            <h4 class="mb-0">Konfirmasi Penerimaan</h4>
            <button class="btn" @click="$emit('closeModal')">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div style="padding: 12px 20px">
            <div class="d-flex align-items-center" style="margin: 24px 0">
                <p style="width: 160px; font-weight: 600; margin: 0">Kode BAST</p>
                <div style="flex-grow: 1; background: #F7F7F7; padding: 8px 12px;">
                    <p class="mb-0">{{ data.bast_no }}</p>
                </div>
            </div>
            <div class="d-flex align-items-center" style="margin: 24px 0">
                <p style="width: 160px; font-weight: 600; margin: 0">POS Asal</p>
                <div style="flex-grow: 1; background: #F7F7F7; padding: 8px 12px;">
                    <p class="mb-0">{{ data.kode_dealer_pos }} - {{ data.pos_name }}</p>
                </div>
            </div>
            <div class="d-flex align-items-center" style="margin: 24px 0">
                <p style="width: 160px; font-weight: 600; margin: 0">Jumlah QR</p>
                <div style="flex-grow: 1; background: #F7F7F7; padding: 8px 12px;">
                    <p class="mb-0">{{ numberWithCommas(data.qty) }}</p>
                </div>
            </div>
            <div class="d-flex align-items-center" style="margin: 24px 0">
                <p style="width: 160px; font-weight: 600; margin: 0">Nama Penerima</p>
                <input type="text" style="flex-grow: 1; border:1px solid #F3F3F3; border-radius: 4px; padding: 8px 12px;" placeholder="" v-model="form.receiver_name">
            </div>
            <div class="d-flex align-items-start" style="margin: 24px 0">
                <p style="width: 160px; font-weight: 600; margin: 0">Tanda Tangan</p>
                <div style="flex-grow: 1; border:1px solid #F3F3F3; border-radius: 4px; position: relative">
                    <vue-signature-pad width="100%" height="120px" ref="signaturePad" />
                    <button style="position: absolute; bottom: 8px; right: 8px; color: #ADADAD; border-radius: 4px; padding: 4px 12px" @click="$refs.signaturePad.clearSignature()">Hapus</button>
                </div>
            </div>
            <div class="d-flex justify-content-end">
                <button class="btn" style="color: #F36F21; width: 100px" @click="$emit('closeModal')">
                    Batal
                </button>
                <button class="btn" style="background: #F36F21; color:white ; width: 100px; margin-left: 20px" @click="submitForm">
                    Konfirmasi
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                form: {
                    receiver_name: null,
                    receiver_signature: null,
                }
            }
        },
        props: ['data'],
        methods : {
            isEmpty (val) {
                return val == null || val == '' || val.length == 0;
            },
            submitForm () {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

                let errors = [];
                if (isEmpty) {
                    errors.push("Signature is required");
                }
                if (this.isEmpty(this.form.receiver_name)) errors.push("Receiver Name is required");

                if (errors.length > 0) {
                    this.$swal.fire({
                        title: "Error",
                        html: `<p>> ${errors.join("<br>> ")}</p>`,
                        icon: "error",
                    });
                    return;
                }

                this.form.receiver_signature = data.split(",")[1];

                this.$http.post(`/api/qrs/return/${this.data.id}/confirm`, this.form)
                .then((resp)=>{
                    this.$swal.fire({
                        title: "Success",
                        text: "Pengembalian QR telah dikonfirmasi",
                        icon: "success",
                    });
                    this.$emit('refreshData');
                    this.$emit('closeModal');
                })
                .catch((err)=>{
                    console.log(err);
                    this.$swal.fire({
                        title: "Error",
                        text: (err && err.message) ? err.message : "Gagal konfirmasi penerimaan",
                        icon: "error",
                    });
                })
            },
        }
    }
</script>
